import { render, staticRenderFns } from "./TeamChatWidget.vue?vue&type=template&id=b47334e6&scoped=true"
import script from "./TeamChatWidget.vue?vue&type=script&lang=js"
export * from "./TeamChatWidget.vue?vue&type=script&lang=js"
import style0 from "./TeamChatWidget.vue?vue&type=style&index=0&id=b47334e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b47334e6",
  null
  
)

export default component.exports